export enum ComponentContext {
  DynamicNotification = 1,
  CertificateBuilder = 2,
  IndexableFormElements = 3,
  FormulaBuilder = 4,
  FormulaBuilderFunctions = 5,
  FormElementMigration = 6,
  DynamicImage = 7,
  ObjectModelDerivedField = 8,
  ListViewFormula = 9,
  FormBuilderConditionalFields = 10,
  FormBuilderInitialStep = 11,
  DetailViewBuilder = 12
}